import * as React from 'react';

import { AnimatedButton } from 'components/Map/AnimatedButton';
import styles from './GetDirectionsButton.module.css';
import { selectDigitalMap } from 'ducks/universal/digitalMap';
import { useSelector } from 'react-redux';
import { useCurrentPosition } from 'hooks/useCurrentPosition';
import MapDisplayContextService from 'components/Map/MapDisplayContextService';
import { DEBUG } from 'lib/util/debug';

export const GetDirectionsButton = ({
  pinKey,
  onCloseChat,
  children,
}: {
  pinKey: string;
  onCloseChat: () => void;
  children: React.ReactNode;
}) => {
  const { currentPositionRef } = useCurrentPosition();

  const currentPosition = currentPositionRef.current;

  const digitalMap = useSelector(selectDigitalMap);

  const destinationPin = digitalMap?.pins.find((pin) => pin.key === pinKey);

  return (
    <div className={styles.container}>
      <AnimatedButton
        className={styles.btn}
        clickedClassName={styles.clicked}
        onClick={() => {
          DEBUG.log('[GetDirectionsButton] clicked', { currentPosition, destinationPin });
          if (currentPosition && destinationPin) {
            MapDisplayContextService.onGetDirections(currentPosition, destinationPin);
            onCloseChat();
          }
        }}
      >
        <img src="/static/images/map/route.svg" alt="" className={styles.icon} />
        <div className={styles.text}>{children}</div>
      </AnimatedButton>
    </div>
  );
};
